/**
 * @lines98/client/ui/dev-exposure — expose `useGameStore` on window for DevTools.
 *
 * Per T-5 brief AC-2: «Можно убедиться через `window.__store?.getState().moves`
 * в DevTools». This is dev-time only — it's safe in production too (Zustand
 * store is read-only externally), but we tuck it under a `__` prefix to mark
 * it as not-public-API.
 *
 * Loaded once from `app.ts` during mount.
 */

import { useGameStore } from '../store/game-store.js';

declare global {
  interface Window {
    __store?: typeof useGameStore;
  }
}

export function exposeStoreToWindow(): void {
  if (typeof window === 'undefined') return;
  window.__store = useGameStore;
}
